import ClientSuspense from '@components/ClientSuspense'
import usePreferences from '@page-components/CheckoutV3/hooks/usePreferences.main'
import {useEffect} from 'react'
import useLazyAnalyticsV2 from '../hooks/useLazyAnalyticsV2'

function TrackCheckoutViewInner() {
  const {preferences} = usePreferences()
  const analyticsV2 = useLazyAnalyticsV2()

  useEffect(() => {
    if (!preferences?._id) return
    analyticsV2.trackInitCheckoutOnAll(preferences)
  }, [preferences?._id])

  return null
}

export default function TrackCheckoutPageView() {
  return (
    <ClientSuspense fallback={null}>
      <TrackCheckoutViewInner />
    </ClientSuspense>
  )
}
